import { Directive } from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

// Create a global directive
const localDateDirective: Directive = {
  mounted(el, binding) {
    const date = binding.value
    const utcDate = dayjs.utc(date)
    const localDate = utcDate.local()
    const formattedDate = localDate.format('DD/MM/YYYY hh:mm:ss')

    el.textContent = formattedDate
  },
}

export default localDateDirective
